import React from "react";

function Setup() {
    return <div>Setup</div>;
}

export default Setup;
